import type { RHFStockFormValues } from '../views/components/RHFStockForm';

/**
 * Converts the flat/scalar RHFStockForm output into the nested patch shape
 * required by the BE's generateStockId and syncBlockedDeltas logic:
 *  - market:         { id: number }
 *  - portOperator:   { supplierNo: number }
 *  - departurePort:  { unLocode: string }
 *  - destinationPort:{ unLocode: string }
 *  - date:           ISO datetime string (already formatted by RHFStockForm)
 *  - blockeds:       [{ holdId: { id: number }, volume: number }]
 *
 * Shared by StockModal (Add Stock) and StockQuickEditModal (inline edit),
 * since both write through the same full-patch endpoints
 * (upsertStockDelta / POST /stock/with-holds).
 */
export const buildStockPatch = (
  formData: RHFStockFormValues
): Record<string, unknown> => ({
  date: formData.date,
  market: formData.market != null ? { id: Number(formData.market) } : null,
  portOperator:
    formData.portOperator != null
      ? { supplierNo: Number(formData.portOperator) }
      : null,
  departurePort: formData.departurePort
    ? { unLocode: formData.departurePort }
    : null,
  destinationPort: formData.destinationPort
    ? { unLocode: formData.destinationPort }
    : null,
  actualInflow: formData.actualInflow,
  forecastInflow: formData.forecastInflow,
  currentStock: formData.currentStock,
  blockeds: (formData.holds ?? []).map((h) => ({
    holdId: h.hold != null ? { id: Number(h.hold) } : null,
    volume: h.volume,
  })),
});
